import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { getDistributionProcessProductDetails } from "@/Api/distributionProcesses";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader } from "lucide-react";
import { DistributionReceipt } from "../DistributionReceipt";

interface DistributionDetailsModalProps {
  contestId: number;
  isOpen: boolean;
  onClose: () => void;
}

export const DistributionDetailsModal = ({
  contestId,
  isOpen,
  onClose,
}: DistributionDetailsModalProps) => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<any[]>([]);

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const response = await getDistributionProcessProductDetails(contestId);
      if (response.ok && response.data?.response) {
        setDetails(response.data.response.data || []);
      }
    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && contestId) {
      fetchDetails();
    }
  }, [isOpen, contestId]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[900px] max-h-[90vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            Detalhes da Distribuição
          </DialogTitle>
          <p className="text-sm text-muted-foreground">
            Comprovantes de distribuição por produto
          </p>
        </DialogHeader>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader className="size-8 animate-spin text-primary" />
          </div>
        ) : details.length === 0 ? (
          <div className="flex items-center justify-center py-12">
            <p className="text-muted-foreground">
              Nenhuma distribuição encontrada para este concurso
            </p>
          </div>
        ) : (
          <ScrollArea className="max-h-[70vh]">
            <div className="space-y-6 pr-4">
              {details.map((productData, index) => (
                <div
                  key={index}
                  className="border-b border-gray-200 pb-6 last:border-0"
                >
                  <DistributionReceipt data={productData} />
                </div>
              ))}
            </div>
          </ScrollArea>
        )}
      </DialogContent>
    </Dialog>
  );
};
